import { getTeamUserList as getTeamUserListApi } from '@/api/team'

const state = {
  namespaced: true,
  state: {
    driversUsers: [],
    purchaseQuantity: 0, // drivers 购买的数量
    avaliableQuantity: 0, // drivers 剩余的邀请数量
    userTotal: 0,
    currentPage: 1, // 当前页
    pageSize: 15, // 每页的数量
    driversStatus: 'all', // 状态筛选 all、active、pending
    driversRequestStatus: false // drivers 用户列表是否请求完成
  },
  mutations: {
    SET_DRIVERS_USERS(state, list) {
      state.driversUsers = list
    },
    SET_DRIVERS_REQUEST_STATUS(state, status) {
      state.driversRequestStatus = status
    },
    SET_PURCHASE_QUANTITY(state, quantity) {
      state.purchaseQuantity = quantity
    },
    SET_AVALIABLE_QUANTITY(state, quantity) {
      state.avaliableQuantity = quantity
    },
    SET_USER_TOTAL(state, total) {
      state.userTotal = total
    },
    SET_CURRENT_PAGE(state, currentPage) {
      state.currentPage = currentPage
    },
    SET_PAGE_SIZE(state, pageSize) {
      state.pageSize = pageSize
    },
    SET_DRIVERS_STATUS(state, status) {
      state.driversStatus = status
    },
    INIT_DRIVER_STATE(state) {
      state.driversUsers = []
      state.purchaseQuantity = 0
      state.avaliableQuantity = 0
      state.userTotal = 0
      state.currentPage = 1
      state.pageSize = 15
      state.driversStatus = 'all'
      state.driversRequestStatus = false
    }
  },
  actions: {
    updateDriversStatus({ commit }, status) {
      commit('SET_DRIVERS_STATUS', status)
    },
    updatePageSize({ commit }, pageSize) {
      commit('SET_PAGE_SIZE', pageSize)
    },
    updateCurrentPage({ commit }, currentPage) {
      commit('SET_CURRENT_PAGE', currentPage)
    },
    getDriverUserList({ state, commit }, search) {
      let params = {
        page: state.currentPage - 1,
        size: state.pageSize,
        status: state.driversStatus.toUpperCase(),
        role: 'DRIVER',
        searchValue: search
      }
      return getTeamUserListApi(params).then(
        result => {
          try {
            let data = result.res.data
            let members = data.members || []
            let contentTotal = data.total_content || 0
            let total = data.total || 0
            let available = data.available || 0
            let totalPage = Math.ceil(contentTotal / state.pageSize)
            if (totalPage < state.currentPage) {
              commit('SET_CURRENT_PAGE', totalPage)
            }
            commit('SET_DRIVERS_USERS', members)
            commit('SET_PURCHASE_QUANTITY', total)
            commit('SET_AVALIABLE_QUANTITY', available)
            commit('SET_USER_TOTAL', contentTotal)
            commit('SET_DRIVERS_REQUEST_STATUS', true)
            return Promise.resolve()
          } catch (error) {
            commit('SET_DRIVERS_REQUEST_STATUS', false)
            return Promise.reject(error)
          }
        },
        error => {
          commit('SET_DRIVERS_REQUEST_STATUS', false)
          return Promise.reject(error)
        }
      )
    },
    initDriverInfo({ commit }) {
      commit('INIT_DRIVER_STATE')
    }
  }
}

export default state
